import { render, staticRenderFns } from "./downloadCode.vue?vue&type=template&id=a8046930&scoped=true"
import script from "./downloadCode.vue?vue&type=script&lang=js"
export * from "./downloadCode.vue?vue&type=script&lang=js"
import style0 from "./downloadCode.vue?vue&type=style&index=0&id=a8046930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8046930",
  null
  
)

export default component.exports